






































import { defineComponent } from "@vue/composition-api";
import { ContentFeedTypeEnum } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import { getPostAllowedFileTypes } from "@/lib/fileHelpers";
import config from "@/config";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIcon from "@/components/BaseIcon";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "ChoosePostType",
  components: { PageTitle, BaseButton, BaseIcon, BaseConfirm },
  props: {
    showChooseType: { type: Boolean, required: true },
    userId: { type: String, required: true },
  },
  setup() {
    const { authUser, authorities } = useAuthUser();
    return {
      authUser,
      authorities,
    };
  },
  data() {
    return {
      contentTypeEnum: ContentFeedTypeEnum,
      processingType: null as ContentFeedTypeEnum | null,
    };
  },
  computed: {
    isAuthor(): boolean {
      return this.authUser?.id === this.userId;
    },
    canCreateEvent(): boolean {
      return checkAuthorities(
        this.authorities,
        this.isAuthor ? ["updateMyEvent", "getMyEvent"] : ["updateAnyEvent", "getAnyEvent"]
      );
    },
    allowedFileTypes(): string[] {
      return getPostAllowedFileTypes();
    },
    featureEvents() {
      return config.featureEvents && this.canCreateEvent;
    },
    featureGoLive(): boolean {
      return checkAuthorities(this.authorities, ["havePublicLivechat"]);
    },
    onlyPostsAllowed() {
      return !this.featureEvents && !this.featureGoLive;
    },
  },
  methods: {
    selectType(type: ContentFeedTypeEnum) {
      if (this.processingType) {
        return;
      }
      this.processingType = type;
      this.$emit("selectType", type, () => (this.processingType = null));
    },
  },
  created() {
    if (this.onlyPostsAllowed) {
      this.processingType = ContentFeedTypeEnum.MEDIA;
      this.$emit("selectType", ContentFeedTypeEnum.MEDIA, () => (this.processingType = null));
    }
  },
});
